'use strict';

module.exports = {
    name: 'en',
    todayLabel: {
        long: 'Today'
    },
    blank: 'Select a date...',
    headerFormat: 'ddd, MMM Do',
    week: {
        dow: 0,
        doy: 4
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/react-infinite-calendar/dist/commonjs/locale.js
// module id = 1719
// module chunks = 1